<template>
    <div>
        <loader v-if="loading" :loading="loading" :fixed="true"></loader>
        <ClientColorButton :inactive-color="true" class="mb-4" @click="saveCopyTo">
            {{ $t("zoneGroups.copyTo") + " -> " + (copyTo === "dashboard" ? $t("zoneGroups.zonesForDashboard") : $t("zoneGroups.zonesForRight")) }}
        </ClientColorButton>
        <div class="zone-groups-columns">
            <div class="zone-groups-column">
                <ZoneGroupsTable
                    :title="$t('zoneGroups.availableZones')"
                    :brand-zones="availableBrandZonesFiltered"
                    :checked-zones="checkedZonesToBelong"
                ></ZoneGroupsTable>
            </div>
            <div class="zone-groups-arrows">
                <div class="d-flex flex-column">
                    <button @click="toBelong()" class="btn zone-groups-btn-switch mb-4"><i class="fa fa-arrow-right fa-lg"></i></button>
                    <button @click="toNotBelong()" class="btn zone-groups-btn-switch"><i class="fa fa-arrow-left fa-lg"></i></button>
                </div>
            </div>
            <div class="zone-groups-column">
                <ZoneGroupsTable
                    :title="$t('zoneGroups.zonesToBelong')"
                    :brand-zones="brandZonesBelongingFiltered"
                    :checked-zones="checkedZonesToNotBelong"
                ></ZoneGroupsTable>
            </div>
        </div>
    </div>
</template>

<script>
import Loader from "@/components/loader/loader";
import ZoneGroupsTable from "@/components/admin/zoneGroups/ZoneGroupsTable";
import brandHasZonesService from "@/services/brandHasZones";

export default {
    components: {
        ZoneGroupsTable,
        Loader
    },
    props: {
        brandZones: {
            type: Array,
            required: true
        },
        brandHasZoneGroups: {
            type: Object,
            required: true
        },
        for: {
            type: String,
            required: true
        },
        copyTo: {
            type: String,
            required: true
        }
    },
    data: () => ({
        loading: false,
        checkedZonesToBelong: [],
        checkedZonesToNotBelong: []
    }),
    computed: {
        availableBrandZonesFiltered() {
            let availableBrandZones = Object.assign([], this.brandZones);
            if (this.for === "right") {
                availableBrandZones = availableBrandZones.filter(bz => !bz.zoneGroupsRights);
            } else if (this.for === "dashboard") {
                availableBrandZones = availableBrandZones.filter(bz => !bz.zoneGroupsDashboard);
            }
            availableBrandZones = this.orderBrandZones(availableBrandZones);
            return availableBrandZones;
        },
        brandZonesBelongingFiltered() {
            let brandZonesBelonging = Object.assign([], this.brandZones);
            if (this.for === "right") {
                brandZonesBelonging = brandZonesBelonging.filter(
                    bz => bz.zoneGroupsRights && bz.zoneGroupsRights.id === this.brandHasZoneGroups.zoneGroups.id
                );
            } else if (this.for === "dashboard") {
                brandZonesBelonging = brandZonesBelonging.filter(
                    bz => bz.zoneGroupsDashboard && bz.zoneGroupsDashboard.id === this.brandHasZoneGroups.zoneGroups.id
                );
            }
            brandZonesBelonging = this.orderBrandZones(brandZonesBelonging);
            return brandZonesBelonging;
        }
    },
    methods: {
        orderBrandZones(brandZones) {
            return brandZones.sort((bz1, bz2) => {
                return bz1.zone.name.toLowerCase() > bz2.zone.name.toLowerCase() ? 1 : -1;
            });
        },
        toBelong() {
            this.brandZones.map(bz => {
                if (this.checkedZonesToBelong.includes(bz.zone.id)) {
                    if (this.for === "right") {
                        bz.zoneGroupsRights = { id: this.brandHasZoneGroups.zoneGroups.id };
                    } else if (this.for === "dashboard") {
                        bz.zoneGroupsDashboard = { id: this.brandHasZoneGroups.zoneGroups.id };
                    }
                } else {
                    if (this.for === "right") {
                        bz.zoneGroupsRights = bz.zoneGroupsRights ? bz.zoneGroupsRights : null;
                    } else if (this.for === "dashboard") {
                        bz.zoneGroupsDashboard = bz.zoneGroupsDashboard ? bz.zoneGroupsDashboard : null;
                    }
                }
                return bz;
            });
            this.checkedZonesToBelong = [];
            this.checkedZonesToNotBelong = [];
            this.saveBrandZones();
        },
        toNotBelong() {
            this.brandZones.map(bz => {
                if (this.checkedZonesToNotBelong.includes(bz.zone.id)) {
                    if (this.for === "right") {
                        bz.zoneGroupsRights = null;
                    } else if (this.for === "dashboard") {
                        bz.zoneGroupsDashboard = null;
                    }
                }
                return bz;
            });
            this.checkedZonesToBelong = [];
            this.checkedZonesToNotBelong = [];
            this.saveBrandZones();
        },
        saveBrandZones() {
            this.loading = true;
            const requestBody = this.brandZones.map(bz => {
                return {
                    id: bz.id,
                    zoneGroupsRights: bz.zoneGroupsRights,
                    zoneGroupsDashboard: bz.zoneGroupsDashboard
                };
            });
            brandHasZonesService
                .save(requestBody)
                .then(() => {
                    this.dialogSuccess("success");
                    this.loading = false;
                })
                .catch(() => {
                    this.dialogError("error");
                    this.loading = false;
                });
        },
        saveCopyTo() {
            this.loading = true;
            const requestBody = [];
            this.brandZones.forEach(bz => {
                if (
                    (this.copyTo === "dashboard" && bz.zoneGroupsRights && bz.zoneGroupsRights.id === this.brandHasZoneGroups.zoneGroups.id) ||
                    (this.copyTo === "right" && bz.zoneGroupsDashboard && bz.zoneGroupsDashboard.id === this.brandHasZoneGroups.zoneGroups.id)
                ) {
                    requestBody.push({
                        id: bz.id,
                        zoneGroupsRights: bz.zoneGroupsRights,
                        zoneGroupsDashboard: bz.zoneGroupsDashboard
                    });
                }
            });
            brandHasZonesService
                .copyTo(this.copyTo, requestBody)
                .then(() => {
                    this.dialogSuccess("success");
                    this.$emit("reload");
                    this.loading = false;
                })
                .catch(() => {
                    this.dialogError("error");
                    this.loading = false;
                });
        }
    },
    created() {}
};
</script>

<style lang="scss" scoped>
.zone-groups-columns {
    display: flex;
    flex-wrap: nowrap;
    align-items: stretch;
}

.zone-groups-column {
    flex: 1 1 0%;
    min-width: 0;
    overflow-x: auto;
}

.zone-groups-arrows {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    padding: 0 15px;
}
</style>



// WEBPACK FOOTER //
// ZoneGroupsTab.vue?244546fa